<template>
    <div class="main-logo">

        <router-link to="/" class="logo">
            <img src="/images/CAC-Logo-Horiz.png" alt="Clean Air Construction logo"/>
            <span style="color:#fff;font-size: 0;max-height:0; display:block;">Clean Air Construction - The Yard</span>
        </router-link>

    </div>
</template>

<script>

import Vue from 'vue'

export default Vue.extend({
    name: 'MainLogo',
})
</script>

<style lang="scss">
@import '../../sass/variables_mixins';

.main-logo {
    display: block;
    //@include vertical-center;
    @include transition(opacity .3s);
    z-index: 10;

    img {
        display: block;
        height: 52px;
        @media (min-width: 1200px) {
            height: 52px;
        }
    }

    &:hover {
        opacity: .5;
    }
}


</style>
